import React, { useEffect, useState } from 'react';
import { Container, Row, Col, FormInput, FormGroup, Form, Button, FormSelect, Card } from 'shards-react';
import PageTitle from '../../components/common/PageTitle';
import Input from '../../components/UI/Input/Input';
import Select from '../../components/UI/Select/Select';
import useForm from './useForm';
import { useTranslation } from 'react-i18next';
import LinearProgress from '@material-ui/core/LinearProgress';
import UserDetails from './UserDetails';
import { CardHeader } from '@material-ui/core';
import Avatar from 'react-avatar';

const UserProfile = () => {
  const { submitHandler, back, loading, field, responseValues, sendPasswordResetEmail } = useForm();
  const { t, i18n } = useTranslation();
  return (
    <>
      {loading && <LinearProgress />}
      <Container fluid className="main-content-container px-4 pb-4">
        <Row noGutters className="page-header py-4">
          <PageTitle title={t('profile.title')} subtitle={t('profile.subtitle')} md="12" className="ml-sm-auto mr-sm-auto" />
        </Row>
        <Row>
          <Col lg="4 ">
            <Card small className="mb-4 pt-3 ">
              <div className="mb-3 mx-auto">
                <Avatar name={`${responseValues.firstName} ${responseValues.lastName}`} size="110" round={true} />
              </div>
              <h4 className="mb-0 text-center">{`${responseValues.firstName} ${responseValues.lastName}`} </h4>
              <span className="text-muted d-block mb-2  text-center">{responseValues.role} </span>
              <Button
                className="mr-5 ml-5 mt-2 mb-2"
                style={{ backgroundColor: 'transparent', border: '1px solid black', color: 'black' }}
                disabled={loading}
                onClick={() => sendPasswordResetEmail()}
              >
                {t('profile.form.reset-password')}
              </Button>
            </Card>
          </Col>

          <Col lg="8">
            <Card small className="mb-4 py-5 px-4">
              <CardHeader className="">
                <h6 className="m-0">{'title'}</h6>
              </CardHeader>
              <form>
                <Row>
                  <Col md="6">
                    <Input
                      type="text"
                      placeholder={t('placeholder.firstName')}
                      label={t('label.firstName')}
                      {...field('firstName')}
                    />
                  </Col>
                  <Col md="6">
                    <Input
                      type="text"
                      placeholder={t('placeholder.lastName')}
                      label={t('label.lastName')}
                      {...field('lastName')}
                    />
                  </Col>
                  <Col md="6">
                    <Select placeholder={t('placeholder.gender')} label={t('label.gender')} {...field('gender')}>
                      <option value="" disabled selected>
                        {t('gender')}
                      </option>
                      <option value="F">{t('female')}</option>
                      <option value="M">{t('male')}</option>
                    </Select>
                  </Col>
                  <Col md="6">
                    <Input
                      type="email"
                      placeholder={t('placeholder.email')}
                      label={t('label.email')}
                      {...field('email')}
                      disabled
                    />
                  </Col>
                  <Col md="6">
                    <Input type="text" placeholder={t('placeholder.phone')} label={t('label.phone')} {...field('phone')} />
                  </Col>

                  <Col md="12" className="d-flex justify-content-end">
                    <Button theme="success" type="button" disabled={loading} onClick={() => submitHandler()}>
                      {t('update')}
                    </Button>
                  </Col>
                </Row>
              </form>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default UserProfile;
